
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tepezza",
      function () {
        return require("private-next-pages/tepezza/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tepezza"])
      });
    }
  